import { Component, OnInit } from '@angular/core';
import { MasterService } from '../service/master.service';
import { NotificationService } from '../core/core.module';
import { ParkBookingService } from '../service/park-booking.service';
import { ParkBookingDetailsModel } from '../model/FormsEntity/parkBookingDetails.model';
import { Time } from '@angular/common';
import { BookingManagementService } from '../service/bookingManagement.service';
import { OnlineBooking } from '../model/FormsEntity/onlineBooking';
import { AreaDescriptionModel } from '../model/masters/areaDescription.model';
import { FloorModel } from '../model/masters/floor.module';
import { LandDescriptionModel } from '../model/masters/landDescription.model';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserManagementService } from '../service/userManagement.service';

@Component({
  selector: 'dda-online-booking',
  templateUrl: './online-booking.component.html',
  styleUrls: ['./online-booking.component.scss'],
})
export class OnlineBookingComponent implements OnInit {
  // park bookin
  ishome:boolean=false;
  isParkbooking:boolean=false;
  isCommunity:boolean=false;
  isAdoption:boolean=false;
  categoryList = [
    {id : 1 , name : "Park (Category - A)" },
    {id : 3 , name : "Park with Amphitheaters (Category -B)" },
  ]
  parkBookingModel:ParkBookingDetailsModel = new ParkBookingDetailsModel();
  parkList:any[]=[];
  park:any;
  timeFrom:Time;timeTo:Time;
  slotCategory:any;
  parkCategory:string;
  parkArea:string;
  maximumCapacity:string;
  ticketProgram:string;
  selectedEduInsti:string;
  selectedElectricity:string;
  selectedDate:Date;
  selectedPark:any;
  checkRatesModel:any;
  getSlotlist:any = [];
  getSubSlotlist:any[];
  ifSubSlot: boolean=false;
  ifName: boolean=false;
  showRates:boolean = false;
  message:string;
  totalCharge:any;
  hiringCharge:any;
  securityAmounts:any;
  electricCharge:any;
  ticketcharge:any;
  bookingCharge:any;
  gst:any
  discount:any;
  statusId:any;
  statusButton:any;
  date = new Date();
  minDate1:Date = new Date();maxDate:Date;
  minDate = new Date(this.date.setDate(this.date.getDate()+7));

  //community hall 
  bookingAreaTypeList:any = [];
  areaTypeList:any = [];
  areacommShow: boolean = false ;
  areaopShow: boolean = false ;
  functypeShow: boolean = false ;
  functypesShow: boolean = false ;
  govShow: boolean = false ;
  brigroShow: boolean = false ;
  anyothShow: boolean = false ;
  calshow: boolean = false ;
  categorytypeShow: boolean = false ;
  functionNameList:any =[];
  ifSeniorExecutive:boolean=false
  functionTypeList:any = [];
  categoryTypeList:any = [];
  icardShow: boolean = false ;
  checkRates:OnlineBooking = new OnlineBooking();
  bookingType:string;
  localityList1:any=[]
  landDescriptionList1:any[] = [];
  landDescriptionList:any = [];
  areaDescription:AreaDescriptionModel[] = null;
  floor:FloorModel;
  landDescriptionModel:LandDescriptionModel = new LandDescriptionModel();
  bookingStartDate = new FormControl(new Date());
  maxDate1:Date;
  date1 = new Date();
  cminDate = new Date(this.date.setDate(this.date1.getDate()+3));
  checkRatesForm = this.fb.group({
    typeOfBooing:[null,Validators.required],
      zone:[null,Validators.required],
     gstin:null,
     moibleNo:null,
     empdda:[null,Validators.required],
     iCard:null ,    
     locality:[null,Validators.required],
     landDescription:[null,Validators.required],
     typeofFunction:[null,Validators.required],
     functionName:[null,Validators.required],
     category:[null,Validators.required],
     anyOther:null,
     areaType:[null,Validators.required],
     floorNo:[null,Validators.required],
     totalArea:null,
     builtArea:null,
     openArea:null,
     actualArea:null,
     requiredArea:null,
     bookingStartDate:[null,Validators.required],
     bookingEndDate:[null,Validators.required],
     netPayableAmount:null,
     bookingCharges:null,
     cleaningCharges:null,
     security:null,
     cgst:null,
     sgst:null,
     categoryType:null,
     status:null,
  });
  empddas= [
    {name: 'Yes', pk:1},
    {name: 'No', pk:2}
  ];
  buildArea:number = null;
  openArea:number = null;
  actualArea:number = null;
  requiredArea:number = null;
  totalArea:number=null;
  categoryName:any;
  fileList:any = [];
  floorList:any[] = [];
  calculations:any = null;
  status:any = null;
  statusName:string = null;
  status0:boolean = false;
  status1:boolean = false;
  deptId: any;
  zoneList:any = [];


  constructor(private masterService:MasterService,private fb: FormBuilder,
    private notificationService: NotificationService, private usermanage: UserManagementService,
    private parkBookingService:ParkBookingService,private booking :BookingManagementService) {
      this.usermanage.departmentList().subscribe(data => {
        console.log(data);
        let deptList = [];
        deptList = data;
        deptList.forEach(element => {
          if (element.departmentName === "Engineering") {
            this.deptId = element.roleId;
          }
          if (this.deptId) {
            this.usermanage.getZoneByDept(this.deptId).subscribe(data => {
              this.zoneList = data;
              this.zoneList = this.zoneList.slice(0,5);
            }
            );
          }
        });
      });
     }

  ngOnInit() {
    this.ishome=true
  }
  menuClick(data)
  {
    this.ishome=false;
    this.isParkbooking=false;
    this.isCommunity=false;
    this.isAdoption=false;
    if(data == 1)
    {
      this.isParkbooking=true;
      this.getSubSlotlist=[]
      this.ifSubSlot=false;
      this.parkList=[]
      this.park = null;
      this.parkCategory = null;
      this.parkArea = null;
      this.maximumCapacity=null
      this.checkRatesModel=[]
      this.parkBookingModel=new ParkBookingDetailsModel()
      this.message=null
      this.showRates=false
      this.statusId=0
      this.getSlot()
    }
    if(data == 2)
    {
       this.isCommunity=true;
       this.checkRatesForm.reset()
       this.areacommShow= false ;
       this.areaopShow=false ;
       this.functypeShow = false ;
       this.functypesShow = false ;
       this.govShow = false ;
       this.brigroShow = false ;
       this.anyothShow = false ;
       this.calshow = false ;
       this.categorytypeShow = false ;
       this.bookingAreaTypeList=[]
       this.areaTypeList=[]
       this.functionTypeList=[]
       this.categoryTypeList=[]
       this.icardShow = false;
       this.bookingType=null
       this.localityList1=[]
       this.landDescriptionList1=[]
       this.checkRates= new OnlineBooking()
       this.floorList=[]
       this.categoryName=null
       this.functionNameList=[]
       this.buildArea=null
       this.calculations=[]
       this.statusName = null
       this.status = null
       this.getbookingAreatype()
       
    }
    if(data == 3)
    {
      // this.isAdoption=true
    }

  }
  getSlot()
  {
    this.masterService.getSlots().subscribe(data=>{
      this.getSlotlist =data;
    })
  }
  getSubSlot(value)
  {
    
    if (value == "Half Day") {
      this.masterService.getSubSlots().subscribe(data=>{
        this.getSubSlotlist = data;
        this.ifSubSlot=true;
      })
      
    } else {
      this.ifSubSlot=false;
    }
  }
  getCategoryType(value){
    this.parkBookingService.getParkBasedOnCategory(value).subscribe(data =>{
      if(data != null){
        this.parkList = data;
      }
    });
  }
  getPark(value){
    this.park = value;
    this.parkCategory = value.parkCategory;
    this.parkArea = value.parkArea;
    this.maximumCapacity = value.maximumCapacity;
    if(value.maximumCapacity == null){
      this.maximumCapacity = "NA";
    }
    if(value.parkArea == null){
      this.parkArea = "NA";
    }
  }
  checkAvailabilityAndRates(){
    this.parkBookingModel.facilityCategory = this.parkCategory;
    this.parkBookingModel.facilityToBeBooked = this.selectedPark.parkDetailsBasedOnCategory;
    this.parkBookingModel.areaOfTheParkedBooked = this.parkArea;
    this.parkBookingService.checkAvailabilityList(this.parkBookingModel).subscribe(data =>{
      if(data != null){
      
        this.checkRatesModel = data.data;     
        if(data.status.id == "1"){
          this.message = data.status.detailMessage;
          this.statusId=1;
          this.showRates = true;
          this.totalCharge = this.checkRatesModel.totalCharge;
        this.hiringCharge = this.checkRatesModel.hiringCharge;
        if(this.checkRatesModel.bookingCharge)
        this.bookingCharge=this.checkRatesModel.bookingCharge
        else
        this.bookingCharge=0
        this.securityAmounts = this.checkRatesModel.securityAmounts;
        this.parkBookingModel.totalCharge = this.totalCharge;
        this.parkBookingModel.hiringCharges = this.hiringCharge;
        this.parkBookingModel.securityAmounts = this.securityAmounts;
        this.parkBookingModel.bookingCharge = this.bookingCharge;
        this.parkBookingModel.sgst=this.checkRatesModel.sgst
        this.parkBookingModel.cgst=this.checkRatesModel.cgst
        this.parkBookingModel.discount=this.checkRatesModel.discount
       this.gst=this.checkRatesModel.sgst
       this.gst=this.checkRatesModel.cgst
        if(this.checkRatesModel.ticketcharge)
        this.ticketcharge = this.checkRatesModel.ticketcharge;
        else
        this.ticketcharge=0
        if(this.checkRatesModel.electricCharge)
        this.electricCharge = this.checkRatesModel.electricCharge;
        else 
        this.electricCharge=0
        this.parkBookingModel.ticketcharge = this.ticketcharge;
        this.parkBookingModel.electricCharge = this.electricCharge;
       // this.parkBookingModel.electricCharges = this.electricCharge;
        }else{
          this.message = data.status.detailMessage;
          this.statusId=2;
          this.showRates = false;
        }  

        if(this.parkBookingModel.educationlInsitute==1)
        {

        
        this.discount=(this.hiringCharge + this.securityAmounts)/2

        this.parkBookingModel.totalCharge = this.parkBookingModel.totalCharge -this.discount
        }
        else
        {
          this.discount=0
        this.parkBookingModel.totalCharge = this.parkBookingModel.totalCharge -this.discount
        }
      }   
    });

  }
  onchange()
  {
    this.showRates=false
  }
  goback()
  {
    this.ishome=true;
    this.isParkbooking=false;
    this.isCommunity=false;
    this.isAdoption=false;

  }
  //community hall
  getbookingAreatype()
  {
    this.booking.getBookingType().subscribe(data=>{
      this.bookingAreaTypeList=data;
    }); 

  }
  typeOfBooingChange(value) {
    let bookingTypePk: number=value;
    this.booking.getCategoryType(bookingTypePk).subscribe(data=>{
        this.areaTypeList = data.areaType;
    });
    if(value === 1){
      this.areacommShow = true; 
      this.categorytypeShow = false; 
      this.booking.getCategoryType(bookingTypePk).subscribe(data=>{
          this.functionTypeList=data.functionTypeList;
      });
    }
    
   else if(value === 2 || 3){
      this.areaopShow = true; 
      this.categorytypeShow = true; 
      this.areacommShow = false;
      this.booking.getCategoryType(bookingTypePk).subscribe(data=>{
          this.categoryTypeList=data.categoryType;
      });
    }
    else{
      this.areaopShow = false; 
      this.categorytypeShow = false;
      this.areacommShow = false;
    }
  }
  emppdaChange(value) {
    if(value === "1"){
      this.icardShow = true; 
    }
    else{
      this.icardShow = false;
    }
  }
  getLocality(value){
    let zonePk: number=value;
    if(this.checkRates.typeOfBooking === 1){
      this.bookingType = "C"
    }else if(this.checkRates.typeOfBooking === 2){
      this.bookingType = "O"
    }else if(this.checkRates.typeOfBooking === 3){
      this.bookingType = "P"
    }
      this.booking.getLocality(zonePk,this.bookingType).subscribe(data=>{
          this.localityList1=data;
      });
  }
  getLandDescription(value: number){
    let localityPk: number=value;
      this.booking.getLandDescription(localityPk).subscribe(data=>{
        this.landDescriptionList1=data.landDescription;
        var list:any[] = [];
        
        console.log("Land Description " + this.landDescriptionList1);
        this.landDescriptionList1.forEach(function(key,value){
          if(key.maintainedBy === "DDA"){
            list.push(key);
          }
        });
        this.landDescriptionList =list;
          this.areaDescription=this.landDescriptionList;
          this.floor;
      });
  }
  getAreaDescription(value){
    this.landDescriptionModel.pk = value;
    let landDescriptionPk = value;
    this.totalArea = value.totalArea;
    this.buildArea = value.buildArea;
    this.openArea = value.openArea;
    this.categoryName = value.category;
    this.checkRates.landDesc = value.pk;
    this.booking.getFloorList(landDescriptionPk.pk).subscribe(data =>{
      this.floorList = data.floor;
    });
  }
  getDate(){
    this.minDate1 = this.checkRatesForm.get('bookingStartDate').value;
  }
  getFunctionType(value){
    let categoryTypeId:Number = value;
       this.booking.getFunType(categoryTypeId).subscribe(data=>{
           this.functionTypeList=data.functionType;
      });
     if(value === 1){
      this.categoryName = "I";
     } else if(value === 2){
      this.categoryName = "II";
     }else if(value === 3){
      this.categoryName = "III";
     }else{
      this.categoryName = "IV";
     }
  }
  typeofFunctionChange(value) {
    let functionTypeId:Number = value;
    this.booking.getFunName(functionTypeId).subscribe(data=>{
        this.functionNameList=data.functionNameList;
    });
    if(value === 3){
      this.functypeShow = true; 
      this.govShow = false; 
      this.functypesShow = false;
    }
    
   else if(value === 4){
      this.functypeShow = true; 
      this.govShow = false; 
      this.functypesShow = false;
    }
    else if(value === 5){
      this.functypeShow = true; 
      this.govShow = false; 
      this.functypesShow = false;
    }
    else if(value === 6){
      this.govShow = true;
      this.functypeShow = false; 
      this.functypesShow = false; 
    }
    else if(value === 7){
      this.govShow = false;
      this.functypeShow = true; 
      this.functypesShow = true; 
    }
    else{
      this.functypeShow = false; 
      this.govShow = false; 
      this.functypesShow = false; 
    }
  }
  functionNameChange(value) {
  
    if(value === "2"){
      this.brigroShow = true; 
      this.anyothShow = false;
      
    }
   else if(value === "3"){
      this.brigroShow = false; 
      this.anyothShow = true;
    }
    else{
      this.brigroShow = false;
      this.anyothShow = false;
    }
  }
  getAreaByFloor(value){
    this.checkRates.floorNo = value.pk;
    if(value.buildArea != null){
      this.buildArea = value.buildArea;
    }
    if(value.openArea != null){
      this.openArea = value.openArea;
    }
  }
  openCalculation(){
    this.booking.checkAvailability(this.checkRates).subscribe(data=>{
        this.calculations=data.data;
        this.statusName = data.status.detailMessage
        this.status = data.status.id;
        if(this.status === "1"){
          this.calshow = true;
          this.status1 = true;
          this.status0 = false;
        }else if(this.status === "0"){
          this.calshow = false;
          this.status1 = false;
          this.status0 = true;
        }
        else{
          this.calshow = false;
        }
    });
    
  }
  onresetcommunity()
  {
    this.calshow=false
    this.status0=false
    this.status1=false
  }


}
